<template>
  <v-app-bar
    id="core-app-bar"
    app
    color="white"
    elevate-on-scroll
    height="96"
  >
    <v-container>
      <v-row>
        <div class="d-flex align-center">
          <a href="/">
            <v-img
              src="../../assets/logo.svg"
              contain
              class="shrink mr-2"
              height="48"
              width="108"
            />
          </a>
        </div>

        <v-spacer />

        <v-toolbar-items
          v-if="$vuetify.breakpoint.smAndUp"
          class="shrink"
        >
          <v-btn
            v-for="(link, i) in links"
            :key="i"
            :to="{
              name: link.url
            }"
            active-class="lushary--text"
            class="subtitle-1 ml-1"
            exact
            min-width="128"
            text
          >
            {{ link.name }}
          </v-btn>
        </v-toolbar-items>

        <v-app-bar-nav-icon
          v-else
          @click="setDrawer(true)"
        />
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
  // Utilities
  import { mapMutations, mapState } from 'vuex'

  export default {
    name: 'CoreAppBar',

    computed: {
      ...mapState(['links', 'urls']),
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
    },
  }
</script>
